import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface ViewBudgetButtonProps {
  budgetId: number;
  showText?: boolean;
  className?: string;
}

export const ViewBudgetButton: React.FC<ViewBudgetButtonProps> = ({
  budgetId,
  showText = true,
  className = '',
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleView = () => {
    navigate(`/budgets/${budgetId}`);
  };

  const baseClasses =
    'flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600';
  const buttonClasses = className ? `${baseClasses} ${className}` : baseClasses;

  return (
    <button onClick={handleView} className={buttonClasses} title={t('budget.view')}>
      {showText && <span>{t('budget.view')}</span>}
    </button>
  );
};
